import { render } from "./UsedPartList.vue?vue&type=template&id=6479ae92&scoped=true"
import script from "./UsedPartList.vue?vue&type=script&lang=js"
export * from "./UsedPartList.vue?vue&type=script&lang=js"

import "./UsedPartList.vue?vue&type=style&index=0&id=6479ae92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6479ae92"]])

export default __exports__